"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderItem = exports.Order = void 0;
var Menu_1 = require("./Menu");
var Order = /** @class */ (function () {
    function Order(_a) {
        var orderId = _a.orderId, locationId = _a.locationId, customer = _a.customer, orderStatus = _a.orderStatus, isActive = _a.isActive, zonesCompleted = _a.zonesCompleted, items = _a.items, totalCost = _a.totalCost, orderPlacedDateTimeUtc = _a.orderPlacedDateTimeUtc, totalCostExVat = _a.totalCostExVat, invoiceId = _a.invoiceId, destination = _a.destination, menuId = _a.menuId, notes = _a.notes;
        this.orderId = orderId;
        this.locationId = locationId;
        this.customer = customer;
        this.orderStatus = orderStatus;
        this.isActive = isActive;
        this.zonesCompleted = zonesCompleted;
        this.items = items;
        this.totalCostExVat = totalCostExVat;
        this.totalCost = totalCost;
        this.orderPlacedDateTimeUtc = orderPlacedDateTimeUtc;
        this.invoiceId = invoiceId;
        this.destination = destination;
        this.menuId = menuId;
        this.notes = notes;
    }
    return Order;
}());
exports.Order = Order;
var OrderItem = /** @class */ (function (_super) {
    __extends(OrderItem, _super);
    function OrderItem(_a) {
        var quantity = _a.quantity, completed = _a.completed, size = _a.size, props = __rest(_a, ["quantity", "completed", "size"]);
        var _this = _super.call(this, props) || this;
        _this.quantity = quantity;
        _this.completed = completed;
        _this.size = size;
        return _this;
    }
    return OrderItem;
}(Menu_1.MenuItem));
exports.OrderItem = OrderItem;
